import { createContext, useContext, type ReactNode } from "react";
import { useServiceWorkerUpdate, type UpdateState } from "./useServiceWorkerUpdate";

interface ServiceWorkerUpdateContextType {
    update: UpdateState;
    laterRelease: boolean;
    applyUpdate: () => void;
    localVersion: string;
    latestVersion: string | undefined;
}

const ServiceWorkerUpdateContext = createContext<ServiceWorkerUpdateContextType | undefined>(undefined);

export const ServiceWorkerUpdateProvider = ({ children }: { children: ReactNode }) => {
    const value = useServiceWorkerUpdate();

    return <ServiceWorkerUpdateContext.Provider value={value}>{children}</ServiceWorkerUpdateContext.Provider>;
};

export const useServiceWorkerUpdateContext = () => {
    const context = useContext(ServiceWorkerUpdateContext);
    if (!context) {
        throw new Error("useServiceWorkerUpdateContext must be used within ServiceWorkerUpdateProvider");
    }

    return context;
};
